// core
import React from "react";

// types

// styles
import cx from "classnames";

// components
import ToolTip from "../../../../common/components/Tooltips/Tooltip";
import QuoteTableCell from "./QuoteTableCell";
import { QuoteTableInfo } from "../../../types/quoteTable/QuoteTableInfo";
import {
    QuoteTableCellComponent,
    QuoteTableCellInfo,
    QuoteTableSectionInfo
} from "../../../types/quoteTable/QuoteTableSectionInfo";

// interfaces
interface IQuoteSectionProps<T extends QuoteTableCellComponent> {
    sectionId: QuoteTableSectionInfo["id"];
    title?: string;
    learnMoreHandler: () => void;
    tooltip?: string[];
    cells: QuoteTableCellInfo<T>[];
    isFirstSection: boolean;
    isLastSection: boolean;
    size: QuoteTableInfo["size"];
    cellComponent: T;
    renderOnError: boolean;
    endCardContent?: QuoteTableInfo["endCardContent"];
}

// functions

// rendering
const QuoteSection: React.FC<IQuoteSectionProps<QuoteTableCellComponent>> = (props) => {
    const {
        sectionId,
        title,
        learnMoreHandler,
        tooltip,
        cells,
        isFirstSection,
        isLastSection,
        size,
        cellComponent,
        renderOnError,
        endCardContent
    } = props;

    const tooltipNode = (
        <React.Fragment>
            {tooltip?.map((tip) => (
                <p key={tip}>{tip}</p>
            ))}
        </React.Fragment>
    );

    return (
        <React.Fragment>
            {title && (
                <div
                    className={cx([
                        "layout-quote-table-section-header",
                        "text-section-header",
                        "text-feature",
                        "panel-tea-green"
                    ])}>
                    <h3 className="text-primary text-zero-margin text-font-size-s text-bolder">
                        {title}
                    </h3>
                    {learnMoreHandler && <a onClick={learnMoreHandler}>Learn more</a>}
                    {tooltip && <ToolTip tooltipContent={tooltipNode} />}
                </div>
            )}
            <div
                id={sectionId.toString()}
                className={cx([
                    "text-feature",
                    "layout-quote-table-row",
                    {
                        "layout-quote-table-row-size--small": size === "small",
                        "layout-quote-table-row-size--large": size === "large",
                        "layout-quote-table-row-size--extra-large": size === "extra-large"
                    }
                ])}>
                {cells.map((s, i) => {
                    if (!s)
                        return (
                            <div key={`error-${i}`} className="layout-quote-table-cell" />
                        );

                    const Component = cellComponent;

                    return (
                        <QuoteTableCell
                            key={s.key}
                            isHighlighted={s.quoteState.isHighlighted}
                            isFirstSection={isFirstSection}
                            isLastSection={isLastSection}
                            isSelected={s.quoteState.isSelected}
                            hasBlockingError={s.quoteState.hasBlockingError}
                            renderOnError={renderOnError}>
                            <Component {...s.props} />
                        </QuoteTableCell>
                    );
                })}
                {endCardContent && (
                    <QuoteTableCell
                        isHighlighted={false}
                        isFirstSection={isFirstSection}
                        isLastSection={isLastSection}
                        isSelected={false}
                        hasBlockingError={true}
                        renderOnError={isFirstSection}
                        className={cx("hide-mobile")}>
                        {endCardContent(sectionId)}
                    </QuoteTableCell>
                )}
            </div>
        </React.Fragment>
    );
};

export default React.memo(QuoteSection);
